export default {
  birthDateInvalid:
    "Invalid date. You must be between 18 and 110 years old (year {{minYear}} to {{maxYear}})",
  documentDateInvalid:
    "Invalid date. Year must be between 2000 and {{maxYear}}",
  maxChars: "Must be at most {{max}} characters",
  fieldRequired: "{{field}} is required",
  fieldMinChars: "{{field}} must be at least {{min}} characters",
  fieldMaxChars: "{{field}} must be at most {{max}} characters",
  fields: {
    firstName: "First name",
    lastName: "Last name",
    taxId: "Tax ID",
    companyName: "Company name",
    vatNumber: "VAT number",
    companyTaxId: "Company tax ID",
    birthDate: "Date of birth",
    birthPlace: "Place of birth",
    street: "Street address",
    postalCode: "Postal code",
    city: "City",
    province: "Province / state",
    country: "Country",
    documentType: "Document type",
    documentNumber: "Document number",
    documentIssuer: "Document issuer",
    documentIssueDate: "Document issue date",
    documentExpiryDate: "Document expiry date",
    contactPhone: "Phone number",
    contactEmail: "Email",
    pec: "PEC (certified email)",
    legalRepName: "Legal representative name",
    accountHolder: "Account holder name",
  },
  invalidEmailFormat: "Invalid email format",
  invalidPhoneFormat:
    "Invalid phone number. Use international format with a + prefix (e.g. +393331234567).",
  invalidNotificationChannel:
    "Select WhatsApp or email for booking notifications",
  invalidNotificationLanguage: "Select a notification language",
  ibanLength: "IBAN must be 15-34 characters",
  documentExpiryBeforeIssue:
    "Expiry date must be the same day as or after the issue date",
} as const;
